import LayoutCommonPage from "@/views/shared/LayoutCommonPage"

export default [
    {
        path: '/login',
        component: LayoutCommonPage,
        children: [
            {
                path: "",
                name: "login",
                component: () => import("@/views/LoginPage.vue"),
                meta: { title: "LoginPage", sidebarElement: false},
                props: { logoFileName: "CentralAmerica.png" }
            },
        ],
        
    }
]


